import PouchDB from "pouchdb-browser";
import pouchdb_find from "pouchdb-find";

PouchDB.plugin(pouchdb_find);
// tslint:disable-next-line
const debug: any = require("pouchdb-debug");
PouchDB.plugin(debug);

let db: PouchDB.Database;

export class DbWrapper {
  public readonly db: PouchDB.Database;
  constructor(dbInstance: PouchDB.Database) {
    console.log("PouchDB Connection established");
    localStorage.setItem("debug", "pouchdb:*");
    this.db = dbInstance;
    db = dbInstance;
  }
}

export { db };
export default new DbWrapper(
  new PouchDB("datev", {
    auto_compaction: true,
    adapter: "idb",
    size: 30
  })
);



// WEBPACK FOOTER //
// ./src/db/index.ts